<div class="topics">
  <div class="title-wrapper">
    <div class="title-wrapper-left">
      <h2 class="title">
        {{ 'pages.service.visitRoom.chooseTopics' | translate }}
      </h2>
      <app-tooltip [marginBottom]="false" text="chooseTopicsTooltipBackoffice" />
    </div>
    <button class="secondary addNewTopic" (click)="addTopic()">
      <i class="bi bi-plus-circle" alt="add"></i>
      {{ 'pages.service.visitRoom.addNewTopic' | translate }}
    </button>
  </div>
  @if (researchTopics.length === 0) {
    <p class="no-topics">{{ 'pages.myWorkspace.noTopics' | translate }}</p>
  }
  @for (researchTopic of researchTopics; track researchTopics) {
    @if ($index < topicsShown || chosenTopics.includes(researchTopic.id!)) {
      <div
        class="topic-wrapper"
        [ngClass]="{
          open: !researchTopicsCollapsed[$index],
          checked: chosenTopics.includes(researchTopic.id!)
        }">
        <div class="topic">
          <div class="name-wrapper" tabindex="0">
            <div class="topic-name">
              <input
                class="form-check-input lna checkbox"
                [disabled]="hasExpiredFiles(researchTopic)"
                [id]="researchTopic.id"
                [checked]="chosenTopics.includes(researchTopic.id!)"
                (click)="updateTopics(researchTopic)"
                type="checkbox"
                name="selectedTopic" />
              <div class="name-researchTopic-wrapper">
                <p>{{ researchTopic.name }}</p>
                @if (hasExpiredFiles(researchTopic)) {
                  <div class="message_wrapper">
                    <img src="/assets/images/danger-exclamation-mark.svg" alt="edit icon" />
                    <small class="error-message">
                      {{ 'pages.client.readersCard.expiredResearchTopicFilesAdviceError' | translate }}
                    </small>
                  </div>
                }
              </div>
            </div>
          </div>

          <div class="actions-row">
            <div class="actions topic-actions">
              <button
                class="link-btn"
                [ngClass]="{ open: !researchTopicsCollapsed[$index] }"
                (click)="researchTopicsCollapsed[$index] = !researchTopicsCollapsed[$index]">
                {{ 'pages.service.visitRoom.fullTopicDesc' | translate }}
                <img
                  [ngClass]="{
                    chevron: true,
                    open: !researchTopicsCollapsed[$index]
                  }"
                  src="assets/images/chevron-icon.svg"
                  alt="arrow" />
              </button>
              @if (researchTopic.isEditable) {
                <button class="link-btn" (click)="editTopic(researchTopic.id!)">
                  <img class="m-0" src="/assets/images/edit-icon.svg" alt="edit icon" />
                  {{ 'pages.client.editTopic' | translate }}
                  <app-tooltip [withMargin]="true" [marginBottom]="false" text="editTopicBackoffice" />
                </button>
              }
            </div>
          </div>
        </div>
        <div class="topic-content" [ngbCollapse]="researchTopicsCollapsed[$index]">
          <app-topic-info [topic]="researchTopic" [showCreateNewButton]="hasExpiredFiles(researchTopic)" [application]="application" />
        </div>
      </div>
    }
  }
  @if (topicsShown < researchTopics.length) {
    <div class="more-topics-wrapper">
      <button class="tertiary more-topics" (click)="topicsShown = topicsShown + TOPICS_SHOWN">
        {{ 'pages.client.moreTopics' | translate: { count: TOPICS_SHOWN, total: researchTopics.length } }}
      </button>
    </div>
  }
</div>
<app-confirm-modal
  [isOpen]="isOpenConfirmBack"
  (confirm)="back(true)"
  (cancel)="isOpenConfirmBack = false"
  title="unsavedChanges"
  confirmText="continue"
  denyText="cancelBack" />
<app-confirm-modal
  [title]="'deleteReadingRoomSubmission'"
  [confirmText]="'delete'"
  [isOpen]="isOpenConfirmDeleteSubmission"
  (confirm)="deleteReadingRoomSubmission()"
  (cancel)="onModalClose()" />
<app-service-form-actions (exit)="back()" (saveDraft)="handleSaveDraft()" (deleteDraft)="handleDeleteDraft()" (continue)="submit(true)" />
